import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    backend: { loadPath: `/locale/{{lng}}.json?v=${process.env.REACT_APP_VERSION}` },
    lng: 'en',
    fallbackLng: 'en',
    load: 'languageOnly',
    interpolation: { escapeValue: false }, // react already safes from xss
    // i18next >= 21 deja el placeholder literal ("Send Feedback{{toSpe}}") cuando falta
    // la variable (skipOnVariables: true por defecto). i18next 17 lo reemplazaba por ''.
    // Se restaura ese comportamiento sin tocar skipOnVariables, que evita re-interpolar valores.
    missingInterpolationHandler: () => '',
  });

export default i18n;
